import React, { createContext, useState, useContext, ReactNode, useEffect } from 'react';

// Define the shape of your context
interface UserContextType {
  order_id: string | null;
  user_id: string | null;
  servicable_pincode: string | null;
  auth_token: string | null;
  city_name: string | null;
  selected_old_product: string | null;
  selected_new_product: string | null;
  base_price: string | null;
  cust_info: object | null;
  personalDetailsPageForm: {
    name: string;
    name_error: boolean;
    email: string;
    email_error: boolean;
    house: string;
    house_error: boolean;
    street: string;
    street_error: boolean;
  };
  allCommanErrors: {
    old_product: string;
    old_product_status: boolean;
    new_product: string;
    new_product_status: boolean;
    serviceable_pincode: string;
    serviceable_pincode_status: boolean;
    store_pincode: string;
    store_pincode_status: boolean;
    store_near_you: string;
    store_near_status: boolean;
    old_brand: string;
    old_brand_status: boolean;
    new_brand: string;
    new_brand_status: boolean;
    invoice_no: string;
    invoice_no_status: boolean;
    select_date: string;
    select_date_status: boolean;
    invoice_upload: string;
    invoice_upload_status: boolean;
    personal_name_status: boolean;
    mobile_status: boolean;
    email_status: boolean;
    house_status: boolean;
    street_status: boolean;
    locality_status: boolean;
    personal_name: string;
    mobile_no: string;
    email: string;
    house: string;
    street: string;
    locality: string;
  };
  setOrderId: (order_id: string | null) => void;
  setUserId: (user_id: string | null) => void;
  setServicablePincode: (servicable_pincode: string | null) => void;
  setAuthToken: (auth_token: string | null) => void;
  setcityName: (city_name: string | null) => void;
  setBasePrice: (base_price: string | null) => void;
  setOldProduct: (selected_old_product: string | null) => void;
  setNewProduct: (selected_new_product: string | null) => void;
  setCustInfo: (cust_info: object | null) => void;
  changeTitleAndMetaTags: (title: string, metaTags: { description?: string; keywords?: string; [key: string]: string | undefined }) => void;
  fetchCsrfToken: () => any;
  allFieldCommanError: (
    field_name: string,
    productPage: boolean,
    personalPage: boolean
  ) => void;
  setProductFormfeildErrors: (
    feilds: string[],
    productPage: boolean,
    personalPage: boolean
  ) => void;
  profileDetailsFormValidation: (event: any, name: string) => void;
  formatDate: (dt: string | undefined) => string;
}

// Create the context with default values
const backendUrl = process.env.REACT_APP_BACKEND_URL
const UserContext = createContext<UserContextType | undefined>(undefined);

export const UserExchangeProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    // Initialize state with values from localStorage if they exist
    const [order_id, setOrderId] = useState<string | null>(
      localStorage.getItem("exchange_order_id")
    );
    const [user_id, setUserId] = useState<string | null>(
      localStorage.getItem("exchange_user_id")
    );
    const [servicable_pincode, setServicablePincode] = useState<string | null>(
      localStorage.getItem("exchange_servicable_pincode")
    );
    const [auth_token, setAuthToken] = useState<string | null>(
      localStorage.getItem("exchange_auth_token")
    );
    const [city_name, setcityName] = useState<string | null>(
      localStorage.getItem("exchange_city_name")
    );
    const [selected_old_product, setOldProduct] = useState<string | null>(
      localStorage.getItem("exchange_selected_old_product")
    );

    const [selected_new_product, setNewProduct] = useState<string | null>(
      localStorage.getItem("exchange_selected_new_product")
    );
    const [base_price, setBasePrice] = useState<string | null>(
      localStorage.getItem("exchange_base_price")
    );
    
    // Parse the cust_info from localStorage (use JSON.parse)
    const [cust_info, setCustInfo] = useState<object | null>(
        localStorage.getItem('cust_info') ? JSON.parse(localStorage.getItem('cust_info') as string) : null
    );
    const [personalDetailsPageForm, setPersonalDetailsPageForm] = useState({
        name: "",
        name_error: false,
        email: "",
        email_error: false,
        house: "",
        house_error: false,
        street: "",
        street_error: false,
        
    })

    const [allCommanErrors, setAllCommanErrors] = useState({
      old_product: "Please select the product",
      old_product_status: false,
      new_product: "Please select the product",
      new_product_status: false,
      serviceable_pincode: "Please enter the pincode",
      serviceable_pincode_status: false,
      store_pincode: "Please enter the store pincode",
      store_pincode_status: false,
      store_near_you: "Please select the store",
      store_near_status: false,
      old_brand: "Please select the brand",
      old_brand_status: false,
      new_brand: "Please select the brand",
      new_brand_status: false,
      invoice_no: "Please enter invoice number",
      invoice_no_status: false,
      select_date: "Please select date of purchase",
      select_date_status: false,
      invoice_upload: "Please upload the invoice",
      invoice_upload_status: false,
      personal_name: "Please enter the name",
      personal_name_status: false,
      mobile_no: "Please enter the mobile number",
      mobile_status: false,
      email: "Please enter the email",
      email_status: false,
      house: "Please enter the house number",
      house_status: false,
      street: "Please enter the street",
      street_status: false,
        locality: "Please select the locality",
      locality_status:false,
    });
    

    // Effects to sync localStorage
  useEffect(() => {
        
        if (order_id) {
            localStorage.setItem("exchange_order_id", order_id);
        } else {
            localStorage.removeItem("exchange_order_id");
        }
    }, [order_id]);

  useEffect(() => {
      // //  
        if (user_id) {
            localStorage.setItem("exchange_user_id", user_id);
        } else {
            localStorage.removeItem("exchange_user_id");
      }
      
    }, [user_id]);

  useEffect(() => {
        
      
        if (servicable_pincode) {
            localStorage.setItem(
              "exchange_servicable_pincode",
              servicable_pincode
            );
        } else {
            localStorage.removeItem("exchange_servicable_pincode");
        }
    }, [servicable_pincode]);

  useEffect(() => {
        
      
        if (auth_token) {
            localStorage.setItem("exchange_auth_token", auth_token);
            localStorage.setItem(
              "exchange_auth_token_timestamp",
              Date.now().toString()
            ); // Save the current timestamp
        } else {
            localStorage.removeItem("exchange_auth_token");
            localStorage.removeItem("exchange_auth_token_timestamp"); // Also remove timestamp
        }
    }, [auth_token]);

  useEffect(() => {
        
        if (city_name) {
            localStorage.setItem("exchange_city_name", city_name);
        } else {
            localStorage.removeItem("exchange_city_name");
        }
    }, [city_name]);

  useEffect(() => {
        
        if (base_price) {
            localStorage.setItem("exchange_base_price", base_price);
        } else {
            localStorage.removeItem("exchange_base_price");
        }
    }, [base_price]);

  useEffect(() => {
        
        if (selected_old_product) {
            localStorage.setItem(
              "exchange_selected_old_product",
              selected_old_product
            );
        } else {
            localStorage.removeItem("exchange_selected_old_product");
        }
    }, [selected_old_product]);

    useEffect(() => {

        if (selected_new_product) {
            localStorage.setItem(
              "exchange_selected_new_product",
              selected_new_product
            );
        } else {
            localStorage.removeItem("exchange_selected_new_product");
        }
    }, [selected_new_product]);

  useEffect(() => {
        
        if (cust_info) {
            localStorage.setItem(
              "exchange_cust_info",
              JSON.stringify(cust_info)
            );
        } else {
            localStorage.removeItem("exchange_cust_info");
        }
    }, [cust_info]);

    const allFieldCommanError = (field_name: any, saveButton: boolean,personalPage:boolean) => {
        if (saveButton) {

            setAllCommanErrors((pre) => ({
              ...pre,
              old_product_status: true,
              new_product_status: true,
              serviceable_pincode_status: true,
              store_pincode_status: true,
              store_near_status: true,
              old_brand_status: true,
              new_brand_status:true,
              invoice_no_status: true,
              select_date_status: true,
                invoice_upload_status: true,
            }));

            

        } else if (personalPage) { 
            setAllCommanErrors((pre) => ({
              ...pre,
              personal_name_status: true,
              mobile_status: true,
              email_status: true,
              house_status: true,
              street_status: true,
              locality_status: true,
            }));
        }
        
        else {
            // //  
            switch (field_name) {
                case "old_product":
                    setAllCommanErrors((pre) => ({
                        ...pre,
                        old_product_status: false,
                    }));
                    break;
                case "new_product":
                      setAllCommanErrors((pre) => ({
                          ...pre,
                          new_product_status: false,
                      }));
                      break;
                case "serviceable_pincode":
                    // //  
                    setAllCommanErrors((pre) => ({
                        ...pre,
                        serviceable_pincode_status: false,
                    }));
                    break;
                case "store_pincode":
                      
                    setAllCommanErrors((pre) => ({
                      ...pre,
                      store_pincode_status: false,
                    }));
                    break
                case "store_near_you":
                      
                    setAllCommanErrors((pre) => ({
                      ...pre,
                      store_near_status: false,
                    }));
                    break
                case "old_brand":
                      
                    setAllCommanErrors((pre) => ({
                      ...pre,
                      old_brand_status: false,
                    }));
                    break

                case "new_brand":
                      setAllCommanErrors((pre) => ({
                        ...pre,
                        new_brand_status: false,
                      }));
                      break
                case "invoice_no":
                      
                    setAllCommanErrors((pre) => ({
                      ...pre,
                      invoice_no_status: false,
                    }));
                    break
                case "select_date":
                      
                    setAllCommanErrors((pre) => ({
                      ...pre,
                      select_date_status: false,
                    }));
                    break
                case "invoice_upload":
                      
                    setAllCommanErrors((pre) => ({
                      ...pre,
                      invoice_upload_status: false,
                    }));
                    break
                case "personal_name":
                      
                    setAllCommanErrors((pre) => ({
                      ...pre,
                      personal_name_status: false,
                    }));
                    break
                case "mobile":
                      
                    setAllCommanErrors((pre) => ({
                      ...pre,
                      mobile_status: false,
                    }));
                    break
                case "email":
                      
                    setAllCommanErrors((pre) => ({
                      ...pre,
                      email_status: false,
                    }));
                    break
                case "house":
                      
                    setAllCommanErrors((pre) => ({
                      ...pre,
                      house_status: false,
                    }));
                    break
                case "street":
                      
                    setAllCommanErrors((pre) => ({
                      ...pre,
                      street_status: false,
                    }));
                    break
                case "locality":
                      
                    setAllCommanErrors((pre) => ({
                      ...pre,
                      locality_status: false,
                    }));
                    break
                  
            
            }
        }
    }

    const setProductFormfeildErrors = (feilds:string[],saveButton:boolean, personalPage:boolean) => {

      for(let feild in feilds){
         allFieldCommanError(feild, saveButton, personalPage);
      }

    }

    const profileDetailsFormValidation = (e: any,name:string) => {
        const {  value } = e.target
        let updatedValue = value.trimStart()
        let lengthError = "Please enter at least 2 characters";
        switch (name) {
            case 'name':
                if (updatedValue.length === 0) {
                   setPersonalDetailsPageForm((prev) => ({
                     ...prev,
                     name: "",
                     name_error: false,
                   })); 
                }
                  else if (updatedValue.length < 2) {
                    setPersonalDetailsPageForm((prev) => ({
                      ...prev,
                      name: lengthError,
                      name_error: true,
                    }));
                  }
            case 'email':
                if (updatedValue.length === 0) {
                   setPersonalDetailsPageForm((prev) => ({
                     ...prev,
                     email: "",
                     email_error: false,
                   })); 
                }
                  else if (updatedValue.length < 2) {
                    setPersonalDetailsPageForm((prev) => ({
                      ...prev,
                      email: lengthError,
                      email_error: true,
                    }));
                  }
            case 'house':
                if (updatedValue.length === 0) {
                   setPersonalDetailsPageForm((prev) => ({
                     ...prev,
                     house: "",
                     house_error: false,
                   })); 
                }
                  else if (updatedValue.length < 2) {
                    setPersonalDetailsPageForm((prev) => ({
                      ...prev,
                      house: lengthError,
                      house_error: true,
                    }));
                  }
            case 'street':
                if (updatedValue.length === 0) {
                   setPersonalDetailsPageForm((prev) => ({
                     ...prev,
                     street: "",
                     street_error: false,
                   })); 
                }
                  else if (updatedValue.length < 2) {
                    setPersonalDetailsPageForm((prev) => ({
                      ...prev,
                      street: lengthError,
                      street_error: true,
                    }));
                  }
      }
        
  }

  const fetchCsrfToken = async  () => {
    const response = await fetch(`${backendUrl}api/v1/csrf-token`,
      {  method: 'GET',
        headers:{
          // Accept:'aplication/json',
          "Content-Type": "application/json",
  
        },
        credentials: "include",
        mode:"cors"
  
      }
    );
    const data = await response.json();
    return data.csrfToken;
  };

  const changeTitleAndMetaTags = async (
    title: string,
    metaTags: { description?: string; keywords?: string; [key: string]: string | undefined }
  ) => {
    try {
        // Update the document title

        if (title) {
            document.title = title;
        } else {
            document.title = "Sell Used Appliances Online in India - Instant Cash & Free Pickup | Selsmart";
        }
  
        // Update or create meta tags
        Object.keys(metaTags).forEach((metaName) => {
            if (metaName === 'cronical_url') return;
            const metaTag = document.querySelector(`meta[name="${metaName}"]`);
            if (metaTag) {
                // Update existing meta tag
                metaTag.setAttribute('content', metaTags[metaName] || `Default ${metaName} for Selsmart`);
            } else {
                // Create new meta tag if it doesn't exist
                const newMetaTag = document.createElement('meta');
                newMetaTag.name = metaName;
                newMetaTag.content = metaTags[metaName] || `Default ${metaName} for Selsmart`;
                document.head.appendChild(newMetaTag);
            }
        });

        if (metaTags.cronical_url) {
            let canonicalLink = document.querySelector('link[rel="canonical"]');
            if (canonicalLink) {
              canonicalLink.setAttribute('href', metaTags.cronical_url);
            } else {
              canonicalLink = document.createElement('link');
              canonicalLink.setAttribute('rel', 'canonical');
              canonicalLink.setAttribute('href', metaTags.cronical_url);
              document.head.appendChild(canonicalLink);
            }
          }
  
        // Cleanup function to reset the title and meta tags when unmounting
        return () => {
            document.title = "Sell Used Appliances Online in India - Instant Cash & Free Pickup | Selsmart";
            Object.keys(metaTags).forEach((metaName) => {
                if (metaName === 'cronical_url') return;
                const metaTag = document.querySelector(`meta[name="${metaName}"]`);
                if (metaTag) {
                    metaTag.setAttribute('content', `Default ${metaName} for Selsmart`);
                }
            });

            const canonicalLink = document.querySelector('link[rel="canonical"]');
            if (canonicalLink) {
              canonicalLink.setAttribute('href', window.location.href);
            }
        };
    } catch (error) {
        //console.error("Error updating title and meta tags:", error);
    }
  };

  const formatDate = (date: string|undefined) => {
    if (!date) return "";
    const newDate = date.split("-");
    const dt = newDate[2] + "-" + newDate[1] + "-" + newDate[0];
    return dt;
  };

    return (
      <UserContext.Provider
        value={{
          order_id,
          user_id,
          servicable_pincode,
          auth_token,
          city_name,
          base_price,
          selected_old_product,
          selected_new_product,
          cust_info,
          personalDetailsPageForm,
          allCommanErrors,
          setOrderId,
          setUserId,
          setServicablePincode,
          setAuthToken,
          setcityName,
          setBasePrice,
          setOldProduct,
          setNewProduct,
          setCustInfo,
          fetchCsrfToken,
          allFieldCommanError,
          profileDetailsFormValidation,
          formatDate,
          changeTitleAndMetaTags,
          setProductFormfeildErrors
        }}
      >
        {children}
      </UserContext.Provider>
    );
};

// Custom hook to use the UserContext
export const useExchangeUser = () => {
    const context = useContext(UserContext);
    if (context === undefined) {
        throw new Error('useUser must be used within a UserProvider');
    }
    return context;
};
